import React from 'react';
import { Location } from '@reach/router';

export default Component => props => (
  <Location>
    {({ location }) => <Component currentPath={location.pathname} {...props} />}
  </Location>
);
